
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { NaturezaDeAcao } from '@app/models/natureza-de-acao.model';

@Injectable()
export class NaturezaDeAcaoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(naturezaDeAcao: NaturezaDeAcao): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/naturezaDeAcao', naturezaDeAcao).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/naturezaDeAcao/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/naturezaDeAcao/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/naturezaDeAcao/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTodos() {
  //   return this.http.get(this.URL_API + "naturezaDeAcao");
  // }


}
